import { createI18n } from 'vue-i18n';
import zh_tw from './zh-TW';
import en_us from './en';
import ja_jp from './ja';
import ko_kr from './kr';
import fr_fr from './fr';
import ru_ru from './ru';
import tr_tr from './tr';
import vi_vn from './vn';
import id_id from './id';

const messages = {
  zh_tw,
  en_us,
  ja_jp,
  ko_kr,
  fr_fr,
  ru_ru,
  tr_tr,
  vi_vn,
  id_id,
};

const language = (navigator.language || 'en').toLocaleLowerCase();

let tempLocale = localStorage.getItem('superAvatarLang');
if(tempLocale && tempLocale != 'en_us' && tempLocale != 'zh_tw' && tempLocale != 'ko_kr') {
  tempLocale = 'en_us';
}
const i18n = createI18n({
  // locale: localStorage.getItem('superAvatarLang') || language.split('-')[0] || 'en_us',
  locale: tempLocale || 'en_us',
  fallbackLocale: 'en_us',
  legacy: false,
  messages,
});

export default i18n;
